import React, { useContext, useEffect, useState } from 'react'
import { AppContext } from '../../context/app'
import useAxios from 'axios-hooks'
import { FAVOURITE_URL } from '../../utils/apiUrls'
import ContentListComponent from '../contentListing/contentListComponent'
import { ContentContext } from '../../context/content'
import { useTranslation } from 'react-i18next'

const Favorites = () => {
  const { t } = useTranslation()
  const title = t('favorites')
  const { setLoader } = useContext(AppContext)
  const [dataList, setDataList] = useState([])
  const { isRequestDone } = useContext(ContentContext)

  const [{ data: contentList, loading: contentListLoading }, favListCall] = useAxios({
    url: FAVOURITE_URL,
    method: 'get',
  })

  useEffect(() => {
    if (isRequestDone) {
      favListCall()
    }
  }, [isRequestDone])

  useEffect(() => {
    if (contentList && contentList.success) {
      setDataList(contentList.data)
    }
  }, [contentList])

  useEffect(() => {
    setLoader(contentListLoading)
  }, [contentListLoading])

  return (
    <ContentListComponent title={title} data={dataList} noContentText={t('favourites_empty')} />
  )
}

export default Favorites
